<template>
  <div>
    <h1>Cursos</h1>
    <v-divider class="my-5"></v-divider>
    <v-simple-table
      fixed-header
    >
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">
            Código
          </th>
          <th class="text-left">
            Nome
          </th>
          <th class="text-left">
            Máquinas
          </th>
          <th class="text-left">
          </th>
        </tr>
        </thead>
        <tbody>
          <tr
            v-for="course in courses"
            :key="course.code"
          >
            <td>{{ course.code }}</td>
            <td>{{ course.name }}</td>
            <td>{{ course.machines }}</td>
            <td>
              <v-btn text :to="{ name: 'EditCourse', params: { courseId: course.id }}" color="success">
                <v-icon left>mdi-pencil</v-icon>
                Editar
              </v-btn>
              <v-btn text disabled color="error">
                <v-icon left>mdi-delete</v-icon>
                Remover
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-alert v-if="!courses.length" type="info">
      Nenhuma curso encontrado.
    </v-alert>
    <v-btn
      :to="{ name: 'CreateCourse' }"
      color="success"
      fab
      x-large
      right
      bottom
      fixed
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
import AdminCourseService from '@/services/admin-course/admin-course.service';

const courseService = new AdminCourseService();

export default {
  name: 'AdminCourses',
  data: () => ({
    courses: [],
  }),
  mounted() {
    courseService.getCourses()
      .then((response) => {
        this.courses = response.data;
      })
      .catch(console.error);
  },
  methods: {
  },
};
</script>

<style scoped>
</style>
